import { all, put, takeLatest} from 'redux-saga/effects';
import { toast } from 'sonner';
import { t } from 'copy/t';
import {
  patchAccount,
  resendEmailConfirmation,
  deleteAccount,
} from 'utils/api';
import { removeItem } from 'utils/localStorage';

import {
  PATCH_ACCOUNT_REQUEST,
  RESEND_EMAIL_CONFIRMATION,
  PUT_ACCOUNT_SUCCESS,
  PUT_ACCOUNT_FAILURE,
  RESEND_EMAIL_CONFIRMATION_SUCCESS,
  RESEND_EMAIL_CONFIRMATION_FAILURE,
  DELETE_ACCOUNT_REQUEST,
  DELETE_ACCOUNT_SUCCESS,
  DELETE_ACCOUNT_FAILURE,
} from './constants';

import {
  putAccountFailure,
  putAccountSuccess,
  resendEmailConfirmationSuccess,
  resendEmailConfirmationFailure,
  deleteAccountSuccess,
  deleteAccountFailure,
} from './actions'

import { authedApiSaga } from 'sagas';
import { signOut } from 'containers/App/actions';

export function* patchAccountFlow({ payload }) {
    yield* authedApiSaga(patchAccount, [{
      ...payload,
    }], putAccountSuccess, putAccountFailure);
}

export function* patchAccountSuccessFlow() {
  toast.success(t('toast.account.updated'));
}

export function* patchAccountFailureFlow({ payload }) {
  // A wrong current password is shown on its own field instead.
  if (payload?.statusCode === 422 && payload?.errors?.current_password) return;
  toast.error(t('toast.account.updateFailed'));
}

export function* resendEmailConfirmationFlow() {
    yield* authedApiSaga(resendEmailConfirmation, [], resendEmailConfirmationSuccess,resendEmailConfirmationFailure);
}

export function* resendEmailConfirmationSuccessFlow() {
  toast.success(t('toast.account.confirmationSent'));
}

export function* resendEmailConfirmationFailureFlow() {
  toast.error(t('toast.account.confirmationFailed'));
}

export function* deleteAccountFlow({ payload }) {
  yield* authedApiSaga(deleteAccount, [{
    ...payload,
  }], deleteAccountSuccess, deleteAccountFailure);
}

export function* deleteAccountSuccessFlow() {
  // Clear the token synchronously: the page-unload below tears down the JS
  // context before the SIGN_OUT saga (deleteSessionFlow) can run, so without
  // this the stale token survives and the next boot's 401 interceptor would
  // redirect to /sign-in instead of /.
  removeItem('authToken');
  yield put(signOut());
  window.location.href = '/';
}

export function* deleteAccountFailureFlow({ payload }) {
  const message = payload?.error || t('toast.account.deleteFailed');
  toast.error(message);
}

export default function* watchAccount() {
  yield all([
    takeLatest(PATCH_ACCOUNT_REQUEST, patchAccountFlow),
    takeLatest(PUT_ACCOUNT_SUCCESS, patchAccountSuccessFlow),
    takeLatest(PUT_ACCOUNT_FAILURE, patchAccountFailureFlow),
    takeLatest(RESEND_EMAIL_CONFIRMATION, resendEmailConfirmationFlow),
    takeLatest(RESEND_EMAIL_CONFIRMATION_SUCCESS, resendEmailConfirmationSuccessFlow),
    takeLatest(RESEND_EMAIL_CONFIRMATION_FAILURE, resendEmailConfirmationFailureFlow),
    takeLatest(DELETE_ACCOUNT_REQUEST, deleteAccountFlow),
    takeLatest(DELETE_ACCOUNT_SUCCESS, deleteAccountSuccessFlow),
    takeLatest(DELETE_ACCOUNT_FAILURE, deleteAccountFailureFlow),
  ]);
}
